export const blockIconsCommunicationDraftsNew = (
	<span className='material-symbols-outlined'>drafts</span>
);
